import { useEffect, useState } from "react";

import Button from "../shared/Button";

import { LOAN_TYPES } from "../../constants/loanTypes";
import { EMPLOYMENT_TYPES } from "../../constants/employmentTypes";
import FormSection from "../../../../common/FormSection/FormSection";
import { Briefcase, Calendar, Landmark, User, Wallet } from "lucide-react";
import { formatCurrency } from "../../utils/formatCurrency";

const INITIAL_FORM = {

    first_name: "",

    last_name: "",

    mother_name: "",

    mobile: "",

    email: "",

    loan_type: "",

    loan_amount: 0,

    tenure_months: 0,

    employment_type: "self_employed",

    monthly_income: 0,

    remarks: "",annual_turnover: 0,
company_vintage: 1000,

};

export default function LeadEditForm({

    lead,

    onSave,

    onCancel

}){

    const [form,setForm]=useState(INITIAL_FORM);

    const [saving,setSaving]=useState(false);

    useEffect(()=>{

        if(lead){

            setForm({

                first_name:lead.first_name || "",

                last_name:lead.last_name || "",

                mother_name:lead.mother_name || "",

                mobile:lead.mobile || 0,

                email:lead.email || "",

                loan_type:lead.loan_type || "",

                loan_amount:lead.loan_amount || 0,

                tenure_months:lead.tenure_months || 0,

                employment_type:
                    lead.employment_type || "self_employed",

                monthly_income:
                    lead.monthly_income || 0,
                    annual_turnover:lead.annual_turnover || 0,
company_vintage: lead.company_vintage ||0,


            });

        }

    },[lead]);

    function update(key,value){

        setForm(previous=>({

            ...previous,

            [key]:value

        }));

    }

    async function handleSave(){

        try{

            setSaving(true);

            await onSave?.({

                ...form,

                loan_amount:
                    Number(form.loan_amount)||0,

                tenure_months:
                    Number(form.tenure_months)||0,

                monthly_income:

                    form.employment_type==="salaried"||form.employment_type==="business"

                    ?

                    Number(form.monthly_income)||0

                    :

                    null

            });

        }

        finally{

            setSaving(false);

        }

    }

    return(

        <div className="crm-edit-form">
  <FormSection

        title="Basic Information"

        description="Customer personal information."

        icon={<User size={18}/>}

    >


            <div className="crm-form-grid">

             <div className="form-group">

    <label>

        First Name

    </label>

    <input

        value={form.first_name}

        onChange={e=>

            update(

                "first_name",

                e.target.value

            )

        }

    />

</div>

<div className="form-group">

    <label>

        Last Name

    </label>

    <input

        value={form.last_name}

        onChange={e=>

            update(

                "last_name",

                e.target.value

            )

        }

    />

</div>

<div className="form-group">

    <label>

        Mother Name

    </label>

    <input

        value={form.mother_name}

        onChange={e=>

            update(

                "mother_name",

                e.target.value

            )

        }

    />

</div>

<div className="form-group">

    <label>

        Mobile Number

    </label>

    <input

        value={form.mobile}

        onChange={e=>

            update(

                "mobile",

                e.target.value

            )

        }

    />

</div>

<div className="form-group">

    <label>

        Email Address

    </label>

    <input

        type="email"

        value={form.email}

        onChange={e=>

            update(

                "email",

                e.target.value

            )

        }

    />

</div>

            </div>
</FormSection>

            <FormSection

        title="Loan Information"

        description="Requested loan details."

        icon={<Landmark size={18}/>}

    >

       
            <div className="crm-form-grid">

               <div className="form-group">

    <label>

        Loan Type

    </label>

    <select

        value={form.loan_type}

        onChange={e=>

            update(

                "loan_type",

                e.target.value

            )

        }

    >

        <option value="">

            Select Loan Type

        </option>

        {

            LOAN_TYPES.map(type=>

                <option

                    key={type.value}

                    value={type.value}

                >

                    {type.label}

                </option>

            )

        }

    </select>

</div>

<div className="form-group">

    <label>

        Loan Amount (₹)

    </label>

    <input

        type="number"

        value={form.loan_amount}

        onChange={e=>

            update(

                "loan_amount",

                e.target.value

            )

        }

    />

</div>

<div className="form-group">

    <label>

        Tenure (Months)

    </label>

    <input

        type="number"

        value={form.tenure_months}

        onChange={e=>

            update(

                "tenure_months",

                e.target.value

            )

        }

    />

</div>

            </div>
</FormSection>
             <FormSection

        title="Employment"

        description="Employment and income information."

        icon={<Briefcase size={18}/>}

    >
          <div className="crm-form-grid">

    <div className="form-group">

        <label>

            Employment Type

        </label>

        <select

            value={form.employment_type}

            onChange={e=>

                update(

                    "employment_type",

                    e.target.value

                )

            }

        >

            {

                EMPLOYMENT_TYPES.map(type=>

                    <option

                        key={type.value}

                        value={type.value}

                    >

                        {type.label}

                    </option>

                )

            }

        </select>

    </div>

    {

        form.employment_type === "salaried" &&

        <div className="form-group">

            <label>

                Monthly Income (₹)

            </label>

            <input

                type="number"

                value={form.monthly_income}

                onChange={e=>

                    update(

                        "monthly_income",

                        e.target.value

                    )

                }

            />

        </div>

    }


{
    form.employment_type === "business" &&

    <>

        <div className="form-group">

            <label>

                Annual Turnover (₹)

            </label>

            <input

                type="number"

                value={form.annual_turnover}

                onChange={e=>

                    update(

                        "annual_turnover",

                        e.target.value

                    )

                }

            />

        </div>

        <div className="form-group">

            <label>

                Monthly Earnings (₹)

            </label>

            <input

                type="number"

                value={form.monthly_income}

                onChange={e=>

                    update(

                        "monthly_income",

                        e.target.value

                    )

                }

            />

        </div>

        <div className="form-group">

            <label>

                Company Vintage (Years)

            </label>

            <input

                type="number"

                min="0"

                value={form.company_vintage}

                onChange={e=>

                    update(

                        "company_vintage",

                        e.target.value

                    )

                }

            />

        </div>

    </>

}
</div>
</FormSection>
             <div className="crm-dialog-footer">

        <Button

            variant="secondary"

            onClick={onCancel}

        >

            Cancel

        </Button>

        <Button

            loading={saving}

            onClick={handleSave}

        >

            Save Changes

        </Button>

    </div>

<style>{`

.crm-edit-form{

    display:flex;

    flex-direction:column;

    gap:24px;

}

.crm-form-grid{

    display:grid;

    grid-template-columns:
        repeat(
            2,
            minmax(0,1fr)
        );

    gap:18px;

}

.form-group{

    display:flex;

    flex-direction:column;

    gap:8px;

}

.form-group label{

    font-size:13px;

    font-weight:600;

    color:#475569;

}

.crm-form-grid input,
.crm-form-grid select{

    width:90%;

    height:46px;

    padding:0 14px;

    border:1px solid #D7DCE3;

    border-radius:12px;

    outline:none;

    background:#FFF;

    font-size:14px;

    transition:.18s;

}

.crm-form-grid input:focus,
.crm-form-grid select:focus{

    border-color:#2563EB;

    box-shadow:
        0 0 0 3px rgba(37,99,235,.12);

}

.crm-dialog-footer{

    display:flex;

    justify-content:flex-end;

    gap:12px;

}

@media(max-width:768px){

.crm-form-grid{

    grid-template-columns:1fr;

}

}

`}</style>

        </div>

    );

}